var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchWithoutCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Cells",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EID/ITShop/Assign-as/menu-with-persona-switch/typing",
    transform: "translate(-15, -283)",
    stroke: "color(display-p3 0.584 0.584 0.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stack",
    transform: "translate(0, 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0, 65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.3333, 12)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "10.6666667 2 13.3333333 4.66666667 10.6666667 7.33333333"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3333333,
    y1: 4.66666667,
    x2: 2.66666667,
    y2: 4.66666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5.33333333 14 2.66666667 11.3333333 5.33333333 8.66666667"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.66666667,
    y1: 11.3333333,
    x2: 13.3333333,
    y2: 11.3333333,
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchWithoutCircle);
export default __webpack_public_path__ + "static/media/switch-without-circle.3f1b9d6ccd7234e144a03f810ab9cbb5.svg";
export { ForwardRef as ReactComponent };